'use strict';

exports.__esModule = true;

var _BaseAnalyticsDataHandler = require('../../AnalyticsManager/BaseAnalyticsDataHandler');

var _BaseAnalyticsDataHandler2 = _interopRequireDefault(_BaseAnalyticsDataHandler);

var _CheckoutOption = require('./enhancedEcommerce/CheckoutOption');

var _CheckoutOption2 = _interopRequireDefault(_CheckoutOption);

var _DigitalOfferRedemptionEvent = require('./events/DigitalOfferRedemptionEvent');

var _DigitalOfferRedemptionEvent2 = _interopRequireDefault(_DigitalOfferRedemptionEvent);

var _ManualOfferRedemptionEvent = require('./events/ManualOfferRedemptionEvent');

var _ManualOfferRedemptionEvent2 = _interopRequireDefault(_ManualOfferRedemptionEvent);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var checkoutOptionsMap = _constants2.default.enhancedEcommerce.checkoutOptionsMap;

var BaseGoogleTagManagerDataHandler = function (_BaseAnalyticsDataHan) {
    _inherits(BaseGoogleTagManagerDataHandler, _BaseAnalyticsDataHan);

    function BaseGoogleTagManagerDataHandler() {
        _classCallCheck(this, BaseGoogleTagManagerDataHandler);

        return _possibleConstructorReturn(this, _BaseAnalyticsDataHan.apply(this, arguments));
    }

    BaseGoogleTagManagerDataHandler.prototype.trackDigitalOfferRedemption = function trackDigitalOfferRedemption(_ref) {
        var offerTitle = _ref.offerTitle;

        this._sendData(new _DigitalOfferRedemptionEvent2.default({ offerTitle: offerTitle }));
    };

    BaseGoogleTagManagerDataHandler.prototype.trackManualOfferRedemption = function trackManualOfferRedemption(_ref2) {
        var offerTitle = _ref2.offerTitle;

        this._sendData(new _ManualOfferRedemptionEvent2.default({ offerTitle: offerTitle }));
    };

    // trackPurchase is not present here because it currently requires a site-specific implementation

    // trackCheckoutStep is not present here because it currently requires a site-specific implementation

    BaseGoogleTagManagerDataHandler.prototype.trackCheckoutOption = function trackCheckoutOption(_ref3) {
        var step = _ref3.step,
            option = _ref3.option;

        if (!checkoutOptionsMap[option]) console.error('Invalid option provided to checkout_option action');else {
            this._sendData(new _CheckoutOption2.default({
                step: step,
                option: checkoutOptionsMap[option]
            }));
        }
    };

    return BaseGoogleTagManagerDataHandler;
}(_BaseAnalyticsDataHandler2.default);

exports.default = BaseGoogleTagManagerDataHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/BaseGoogleTagManagerDataHandler.js
// module id = 853
// module chunks = 0